import {Service} from "./service";
import {User} from "./user";

export class Company {
    id: string = '';
    name: string = '';
    domain: string = '';
    shopDomain: string = '';
    sendingEmail: string = '';
    receivingEmail: string = '';
    fiscalCode: string = '';
    vat: string = '';
    sdi: string = '';
    pec: string = '';
    address: string = '';
    addressNumber?: number;
    zip: string = '';
    city: string = '';
    province: string = '';
    logoUrl: string = '';
    legalFirstName: string = '';
    legalLastName: string = '';
    legalPassword?: string;
    legalFiscalCode: string = '';
    legalDocumentNumber: string = '';
    legalEmail: string = '';
    legalPhone: string = '';
    legalAddress: string = '';
    legalAddressNumber?: number;
    legalZip: string = '';
    legalCity: string = '';
    legalProvince: string = '';
    nexiShopId?: string;
    nexiApiKey?: string;
    nexiEnabled?: number;
    wireTransferEnabled?: number;
    wireTransferIban?: string;
    wireTransferBeneficiary?: string;
    nexiRatesEnabled?: number;
    nexiRatesShopId?: string;
    nexiRatesApiKey?: string;
    nexiRatesCommissionPercent?: number;
    localPaymentEnabled?: number;
    otp: string = '';
    acceptTerms: string = '';
    acceptPrivacy: string = '';
    acceptRenew: string = '';
    status: string = '';
    agentId: string = '';
    createdAt?: string;
    rulesUrl?: string;
    legalDocumentFront?: string;
    legalDocumentBack?: string;
    legalFiscalCodeFront?: string;
    legalFiscalCodeBack?: string;
    commissionPercent?: number;
    signature?: string;
    shipmentPrice?: number;
    service: Service = new Service();
    privacyPolicyUrl?: string;
    iubendaScript?: string;
    cookiePolicyUrl?: string;
    appPagoRatesEnabled?: number;
    appPagoShopId?: string;
    appPagoCommissionPercent?: number;
    appPagoApiKey?: string;
    appPagoApiSecret?: string;
    posNexiEnabled?: number;
    posNexiBusinessId?: string;
    posNexiDeviceId?: string;
    posNexiShopId?: string;
    posNexiApiKey?: string;
    posNexiCommissionPercent?: number;
    agent?: User[] = [];
    companyEmail?: string;
    iban?: string;
    federation?: string;
    assignedCode?: string;
    billedPeriod?: string;
    stripeCustomerId?: string;
    stripeSubscriptionId?: string;
    stripeSubscriptionStatus?: string;
    stripeSubscriptionCurrentPeriodEnd?: number;
    stripeSubscriptionCancelAt?: number;

    constructor(raw?: Company) {
        if (raw) {
            this.id = raw.id;
            this.name = raw.name;
            this.domain = raw.domain;
            this.shopDomain = raw.shopDomain;
            this.sendingEmail = raw.sendingEmail;
            this.receivingEmail = raw.receivingEmail;
            this.fiscalCode = raw.fiscalCode;
            this.vat = raw.vat;
            this.sdi = raw.sdi;
            this.pec = raw.pec;
            this.address = raw.address;
            this.addressNumber = raw.addressNumber;
            this.zip = raw.zip;
            this.city = raw.city;
            this.province = raw.province;
            this.logoUrl = raw.logoUrl;
            this.legalFirstName = raw.legalFirstName;
            this.legalLastName = raw.legalLastName;
            this.legalPassword = raw.legalPassword;
            this.legalFiscalCode = raw.legalFiscalCode;
            this.legalDocumentNumber = raw.legalDocumentNumber;
            this.legalEmail = raw.legalEmail;
            this.legalPhone = raw.legalPhone;
            this.legalAddress = raw.legalAddress;
            this.legalAddressNumber = raw.legalAddressNumber;
            this.legalZip = raw.legalZip;
            this.legalCity = raw.legalCity;
            this.legalProvince = raw.legalProvince;
            this.nexiShopId = raw.nexiShopId;
            this.nexiApiKey = raw.nexiApiKey;
            this.nexiEnabled = raw.nexiEnabled;
            this.wireTransferEnabled = raw.wireTransferEnabled;
            this.wireTransferIban = raw.wireTransferIban;
            this.wireTransferBeneficiary = raw.wireTransferBeneficiary;
            this.nexiRatesEnabled = raw.nexiRatesEnabled;
            this.nexiRatesShopId = raw.nexiRatesShopId;
            this.nexiRatesApiKey = raw.nexiRatesApiKey;
            this.nexiRatesCommissionPercent = raw.nexiRatesCommissionPercent;
            this.posNexiEnabled = raw.posNexiEnabled;
            this.posNexiBusinessId = raw.posNexiBusinessId;
            this.posNexiDeviceId = raw.posNexiDeviceId;
            this.posNexiShopId = raw.posNexiShopId;
            this.posNexiApiKey = raw.posNexiApiKey;
            this.posNexiCommissionPercent = raw.posNexiCommissionPercent;
            this.otp = String((raw as Company & {OTP?: string; otpCode?: string}).otp
                || (raw as {OTP?: string}).OTP
                || (raw as {otpCode?: string}).otpCode
                || '').trim();
            this.acceptTerms = raw.acceptTerms;
            this.acceptPrivacy = raw.acceptPrivacy;
            this.acceptRenew = raw.acceptRenew;
            this.status = raw.status;
            this.agentId = raw.agentId;
            this.createdAt = raw.createdAt;
            this.rulesUrl = raw.rulesUrl;
            this.legalDocumentFront = raw.legalDocumentFront;
            this.legalDocumentBack = raw.legalDocumentBack;
            this.legalFiscalCodeFront = raw.legalFiscalCodeFront;
            this.legalFiscalCodeBack = raw.legalFiscalCodeBack;
            this.commissionPercent = raw.commissionPercent;
            this.localPaymentEnabled = raw.localPaymentEnabled;
            this.signature = raw.signature;
            this.shipmentPrice = raw.shipmentPrice;
            this.privacyPolicyUrl = raw.privacyPolicyUrl; // Aggiunto
            this.iubendaScript = raw.iubendaScript;       // Aggiunto
            this.cookiePolicyUrl = raw.cookiePolicyUrl;     // Aggiunto
            this.appPagoRatesEnabled = raw.appPagoRatesEnabled;
            this.appPagoShopId = raw.appPagoShopId;
            this.appPagoCommissionPercent = raw.appPagoCommissionPercent;
            this.appPagoApiKey = raw.appPagoApiKey;
            this.appPagoApiSecret = raw.appPagoApiSecret;
            this.agent = raw.agent;
            this.companyEmail = raw.companyEmail;
            this.iban = raw.iban;
            this.federation = raw.federation;
            this.assignedCode = raw.assignedCode;
            this.billedPeriod = raw.billedPeriod;
            this.stripeCustomerId = raw.stripeCustomerId;
            this.stripeSubscriptionId = raw.stripeSubscriptionId;
            this.stripeSubscriptionStatus = raw.stripeSubscriptionStatus;
            this.stripeSubscriptionCurrentPeriodEnd = raw.stripeSubscriptionCurrentPeriodEnd;
            this.stripeSubscriptionCancelAt = raw.stripeSubscriptionCancelAt;

            if (raw.service) this.service = new Service(raw.service);
        }
    }
}
